import { createV3Queries } from "@query/utils/createV3Queries";
import { workDefinitionsApi } from "@api";

/**
 * Work-definition (template) registry — mirrors `WorkDefinitionsApi` 1:1. The
 * name-derived defaults refresh the sibling reads (`getWorkDefinition` /
 * `listWorkDefinitions`) after every write, which is all the v1 hooks did.
 *
 * The standalone `/v3/payments/work-definitions` list was observed returning 501
 * during earlier migrations. That is no longer true: probed on integration
 * 2026-09-14 across six account scopes, `listWorkDefinitions` answered 200 every
 * time (1 row for a payer fixture, 0 for contractor accounts). The side-nav
 * gating in `useGetDashboardFocusedFeaturesContext` now depends on it.
 */
export const queriesWorkDefinitions = createV3Queries(
  "workDefinitionsApi",
  workDefinitionsApi
);
